import { Card, Grid } from '@design-systems/canvas-ui'
import React from 'react'
import { useEssentials } from 'hooks/utils/useEssentials'
import { TRANSLATION_KEYS } from 'locales/translation-keys'
import { formatPercent } from 'utils/number-format'
import { formatCurrencyString, formatCurrency } from 'utils/currency-helper'
import { SalesData } from './helpers'

interface BrandSalesCardProps {
    data: SalesData[]
    totalSales: number | string | null
    isIntraDay: boolean
}

const toNumber = (value: number | string | null) =>
    typeof value === 'number' ? value : Number(value ?? 0)

const BrandSalesCard: React.FC<BrandSalesCardProps> = ({
    data,
    totalSales,
    isIntraDay,
}) => {
    const hasData = Array.isArray(data) && data.length > 0
    const { t } = useEssentials()
    const { brands } = TRANSLATION_KEYS

    return (
        <Card className="hc8-pa-6x hc8-mb-6x hc8-mt-4x brand-card">
            <Grid.Container justify="center" className="hc8-fs-200">
                <Grid.Item
                    className={`hc8-ta-center ${
                        (typeof totalSales === 'string' &&
                            totalSales.startsWith('-')) ||
                        (typeof totalSales === 'number' && totalSales < 0)
                            ? 'hc-clr-error'
                            : ''
                    }`}
                    size={{
                        xs: 12,
                    }}
                >
                    {isIntraDay
                        ? formatCurrencyString(
                              formatCurrency(toNumber(totalSales)),
                          )
                        : formatCurrencyString(totalSales ?? '0')}
                </Grid.Item>
            </Grid.Container>
            {hasData ? (
                data.map((item, index) => (
                    <Grid.Container key={index}>
                        <Grid.Item
                            className="hc8-pr-none hc8-pl-none"
                            size={{
                                xs: 4,
                            }}
                        >
                            {item.key}
                        </Grid.Item>
                        {item.value !== null && (
                            <Grid.Item
                                className={`hc8-pa-2x hc8-ta-right ${
                                    (typeof item.value === 'string' &&
                                        item.value.startsWith('-')) ||
                                    (typeof item.value === 'number' &&
                                        item.value < 0)
                                        ? 'hc-clr-error'
                                        : ''
                                }`}
                                size={{
                                    xs: 4,
                                }}
                            >
                                {isIntraDay
                                    ? formatCurrencyString(
                                          formatCurrency(toNumber(item.value)),
                                      )
                                    : formatCurrencyString(item.value)}
                            </Grid.Item>
                        )}
                        <Grid.Item
                            className={`hc8-pa-2x hc8-ta-right ${
                                (typeof item.percentage === 'string' &&
                                    item.percentage.includes('-')) ||
                                (typeof item.percentage === 'number' &&
                                    item.percentage < 0)
                                    ? 'hc-clr-error'
                                    : ''
                            }`}
                            size={{
                                xs: 4,
                            }}
                        >
                            {formatPercent(
                                typeof item.percentage === 'number'
                                    ? item.percentage
                                    : parseFloat(item.percentage),
                            )}
                        </Grid.Item>
                    </Grid.Container>
                ))
            ) : (
                <Grid.Container justify="center" className="hc8-pa-2x">
                    <Grid.Item
                        className="hc8-ta-center"
                        size={{
                            xs: 12,
                        }}
                    >
                        {t(brands.noData)}
                    </Grid.Item>
                </Grid.Container>
            )}
        </Card>
    )
}

export default BrandSalesCard
